<template>
<div @click="onItemClicked" class="flex flex-row items-center cursor-pointer">    
      <div class="flex flex-wrap">
        <!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 54 54" style="enable-background:new 0 0 54 54;" xml:space="preserve" width="30px" height="30px">
<g>
	<path d="M1,9h3v4c0,0.553,0.447,1,1,1h12c0.553,0,1-0.447,1-1V9h35c0.553,0,1-0.447,1-1s-0.447-1-1-1H18V3c0-0.553-0.447-1-1-1H5   C4.447,2,4,2.447,4,3v4H1C0.447,7,0,7.447,0,8S0.447,9,1,9z M6,4h10v8H6V4z" fill="#606f7b"/>
	<path d="M53,26H34v-4c0-0.553-0.447-1-1-1H21c-0.553,0-1,0.447-1,1v4H1c-0.553,0-1,0.447-1,1s0.447,1,1,1h19v4c0,0.553,0.447,1,1,1   h12c0.553,0,1-0.447,1-1v-4h19c0.553,0,1-0.447,1-1S53.553,26,53,26z M32,31H22v-8h10V31z" fill="#606f7b"/>
	<path d="M53,45h-3v-4c0-0.553-0.447-1-1-1H37c-0.553,0-1,0.447-1,1v4H1c-0.553,0-1,0.447-1,1s0.447,1,1,1h35v4c0,0.553,0.447,1,1,1   h12c0.553,0,1-0.447,1-1v-4h3c0.553,0,1-0.447,1-1S53.553,45,53,45z M48,50H38v-8h10V50z" fill="#606f7b"/>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
      </div>
      <div class="mx-3">
        <div class="flex text-grey-darker leading-none text-xl">Logout</div>
      </div> 
    </div>
</template>

<script>
export default {
  name: "NavigationItemSettings",
  data() {
    return {
      isActive: false
    };
  },

  methods: {
    onItemClicked() {
      this.$root.$emit("onNavigateToSettings");
    },
  },

  computed: {
    href() {
      //return "#" + this.title.toLowerCase().replace(/ /g, "-");
    }
  },
  mounted() {
    this.isActive = this.selected;
  }
};
</script>


// WEBPACK FOOTER //
// src/components/navigation/NavigationItemSettings.vue